import { useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import CloseButtonSVG from '@Assets/close-button.svg?react';
import { CasdoorContext } from '../../containers/App/casdoor.context';
import { AssignmentMediaPreview } from '../AssignmentMediaPreview';

export const AssignmentMediaViewer = ({
  url,
  watermark,
}: {
  url: string;
  watermark?: string;
}) => {
  const [open, setOpen] = useState(false);
  const { user } = useContext(CasdoorContext);
  const watermarkContent = watermark ?? (user ? (user.displayName ?? user.name) : undefined);

  const handleOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    setOpen(true);
  };

  const handleClose = (e?: React.MouseEvent) => {
    e?.stopPropagation();
    setOpen(false);
  };

  return (
    <>
      <div
        className="absolute inset-0 cursor-pointer"
        onClick={handleOpen}
        role="button"
        aria-label="查看作业"
      >
        <AssignmentMediaPreview url={url} thumbnail />
      </div>

      {open &&
        createPortal(
          <div className="fixed inset-0 z-[9999]">
            <div className="absolute inset-0 bg-black/80" onClick={handleClose} />
            <div className="absolute inset-0 z-10 flex items-center justify-center p-8 pointer-events-none">
              <div className="relative h-full w-full max-h-[90vh] max-w-[90vw] pointer-events-auto">
                <CloseButtonSVG
                  className="absolute right-4 top-4 z-20 h-6 w-6 cursor-pointer fill-white"
                  onClick={handleClose}
                />
                <AssignmentMediaPreview
                  url={url}
                  thumbnail={false}
                  watermark={watermarkContent}
                />
              </div>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};
